import { ConfiguratorUIElementEvent, ConfiguratorUIElementEventListener } from './events';
import { IUiCfgContainer } from '@canvas-logic/clp-api-types';

export abstract class ElementState {
  id = '';
  abstract readonly elementKind: string;
  abstract readonly elementType: string;
  protected listeners: ConfiguratorUIElementEventListener[] = [];

  addEventListener(listener: ConfiguratorUIElementEventListener) {
    this.listeners.push(listener);
  }

  removeEventListener(listener: ConfiguratorUIElementEventListener) {
    this.listeners = this.listeners.filter((l) => l !== listener);
  }

  removeEventListeners() {
    this.listeners = [];
  }

  notify(event: ConfiguratorUIElementEvent) {
    this.listeners.forEach((listener) => listener(event));
  }

  update(): void {}
}

export abstract class ContainerStateBase extends ElementState {
  readonly elementKind = 'container';

  protected constructor(public children: ConfiguratorUIElementStates[], public viewElement: IUiCfgContainer) {
    super();
  }
}

export type ConfiguratorUIElementStates = ElementState | ContainerStateBase;

/**
 * The base `ElementState` declares no `viewElement`, but container and attribute states
 * both add one. Renderers that key children off the config element and fall back to
 * `state.id` use this to read that optional field without asserting a concrete subclass.
 */
export const viewElementId = (state: ConfiguratorUIElementStates): string | undefined =>
  (state as { viewElement?: { id?: string } }).viewElement?.id;
